<template>
	<div id="app">
		<transition
			mode="out-in"
			enter-active-class="fadeIn"
			leave-active-class="fadeOut"
			appear
		>
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
import { getToken } from "./utils/auth";
export default {
	name: "APP",
	mounted() {
		if (
			getToken() &&
			+new Date() - new Date("2025-08-01 00:00:00").getTime() < 0
		) {
			const h = this.$createElement;
			this.$alert(
				h("div", null, [
					h(
						"p",
						null,
						"1、升级包月版的安装，更新“绑定多IP+通用包安装模式”，可以连锁多店共用套餐；"
					),
					h("p", null, "2、云机房安装部署更加便捷；"),
					h("p", null, "3、网吧可以自定义台数套餐，常年充送活动。"),
				]),
				"野豹游戏加速器网吧版本2025年5月升级通知"
			);
		}
	},
};
</script>

<style lang="scss">
.custom-alert {
	width: 563px !important;
}

blockquote,
body,
dd,
dl,
dt,
fieldset,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
html,
iframe,
legend,
li,
ol,
p,
pre,
textarea,
ul {
	margin: 0;
	padding: 0;
}
.table_title {
	border: 1px solid #ebeef5;
	border-bottom: 0px;
	text-align: center;
	font-size: 18px;
	font-weight: bold;
	height: 49px;
	line-height: 49px;
	background: #f1f6f9;
}
.main-header {
	background: #242f42 !important;
}
.main-header .navbar .navbar-custom-menu {
	color: #fff !important;
}
.main-sidebar .vue-scrollbar .sidebar {
	background: #313148 !important;
}
.main-sidebar.expandSide {
	background: #313148 !important;
}
.el-menu {
	background: #313148 !important;
}
.main-sidebar
	.vue-scrollbar
	.sidebar
	.el-menu-style
	.el-submenu
	.el-menu-item
	span {
	color: #fff;
}
.el-menu-item {
	color: #fff !important;
	border-left: 5px solid transparent;
}
.el-form-item {
	margin-bottom: 0px !important;
}
.main-sidebar
	.vue-scrollbar
	.sidebar
	.el-menu-style
	.el-submenu
	.el-menu-item.is-active
	span {
	color: #fdcf13 !important;
}
.el-menu-style {
	height: 570px;
}
.el-submenu__title * {
	color: #fff !important;
}
.el-menu-item.is-active {
	border-left: 5px solid #fdcf13;
	border-radius: 1px;
	color: #fdcf13 !important;
}
.el-dialog__body {
	padding: 20px !important;
}
.el-menu {
	// height:800px;
}
// .el-input__inner:not(.el-date-editor){
//      height: 50px !important;
//       background-color: #F5F5F5 !important ;
//       border: 1px solid #DDDDDD !important;
//       color: #999999 !important;
//   }
//   .el-form-item__label{
//     line-height: 50px !important;
//   }
html,
body,
#app {
	height: 100%;
	padding: 0;
	margin: 0;
}
.main-header .logo .logo-lg b {
	color: #fff !important;
}
.el-dropdown {
	//  color: #fff!important;
}
.main-header .navbar {
	background: #fff !important;
}
*,
:after,
:before {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
}
.main-sidebar .vue-scrollbar {
	background: #313148 !important;
}
ul {
	width: auto !important;
}
a,
a:focus,
a:hover {
	color: inherit;
	cursor: pointer;
	text-decoration: none;
}
.el-dropdown:hover span {
	//  color: #FDCF13!important;
}
.el-button--goon.is-active,
.el-button--goon:active {
	background: #537fed;
	border-color: #537fed;
	color: #fff;
}

.el-button--goon:focus,
.el-button--goon:hover {
	background: #769dff;
	border-color: #769dff;
	color: #fff;
}
.el-button--goon {
	color: #fff;
	background-color: #6692ff;
	border-color: #6692ff;
}
.el-date-editor .el-range-separator {
	padding: 0 !important ;
	line-height: 32px !important;
	width: 5% !important;
}

.el-submenu__title * {
	padding-left: 4px !important;
}

.el-submenu__title {
	//  padding-left: 25px !important;
}
.el-dialog__footer {
	// text-align: center !important;
}
.el-menu-item [class^="el-icon-"] {
	margin-right: 10px !important;
}
.el-submenu__title [class^="el-icon-"] {
	margin-right: 10px !important;
}
.adv {
	width: 200px;
	position: absolute;
	bottom: 20px;
	left: 40px;
	z-index: 99999;
}
</style>
